import {
  Box,
  Card,
  CardContent,
  Skeleton,
  Grid
} from '@mui/material';

/**
 * Skeleton loader for budget/ledger cards
 */
export const CardSkeleton = ({ count = 3 }) => {
  return (
    <Grid container spacing={3}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid
          key={index}
          size={{
            xs: 12,
            sm: 6,
            md: 4
          }}>
          <Card>
            <CardContent>
              <Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="40%" height={40} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="30%" height={20} />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

/**
 * Skeleton loader for transaction lists
 */
export const TransactionListSkeleton = ({ count = 5 }) => {
  return (
    <Box>
      {Array.from({ length: count }).map((_, index) => (
        <Card key={index} sx={{ mb: 2 }}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box flex={1}>
                <Skeleton variant="text" width="40%" height={24} sx={{ mb: 0.5 }} />
                <Skeleton variant="text" width="60%" height={20} />
              </Box>
              <Box textAlign="right">
                <Skeleton variant="text" width={80} height={24} sx={{ mb: 0.5 }} />
                <Skeleton variant="text" width={60} height={20} />
              </Box>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

/**
 * Skeleton loader for dashboard cards
 */
export const DashboardCardSkeleton = () => {
  return (
    <Card>
      <CardContent>
        <Skeleton variant="text" width="50%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="70%" height={40} />
      </CardContent>
    </Card>
  );
};

/**
 * Skeleton loader for balance display
 */
export const BalanceSkeleton = ({ width = "40%" }) => {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Skeleton variant="circular" width={20} height={20} />
      <Skeleton variant="text" width={width} height={24} />
    </Box>
  );
};

/**
 * Skeleton loader for list items
 */
export const ListItemSkeleton = ({ count = 3 }) => {
  return (
    <Box>
      {Array.from({ length: count }).map((_, index) => (
        <Box key={index} sx={{ mb: 2, p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box>
              <Skeleton variant="text" width={120} height={20} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width={80} height={16} />
            </Box>
            <Skeleton variant="text" width={60} height={20} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default {
  CardSkeleton,
  TransactionListSkeleton,
  DashboardCardSkeleton,
  BalanceSkeleton,
  ListItemSkeleton
};